<div *ngIf="!isLoading; else spinner">
  <mat-dialog-content>
    <h1 id="heading">Edit {{title}}</h1>
    <div class="container">
      <app-edit-tag [tags]="tags" [business]="business" (change)="checkBoxChanged()" (error)="handleError($event)"></app-edit-tag>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button [disabled]="disableClose" class="mat-raised-button" (click)="close()">Close</button>
  </mat-dialog-actions>
</div>
<ng-template #spinner>
  <div class="spinnerContainer">
    <mat-spinner  class="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </div>
</ng-template>
